import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import {
  adminCreateCheckpoint,
  adminDeleteSpecificCheckpoint,
  exportCheckpointMaster,
  getDocumentCheckpoint,
} from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import FilterForm from "@components/common/AddFilter/FilterForm";
import NavigationBar from "@components/NotificationBarCheckpoint/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import {
  adminGetCheckpointCountriesListManagement,
  adminGetCheckpointStatesListManagement,
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterCheckpointCategoryOfLawList,
  getSmartFilterCheckpointEvent,
  getSmartFilterCheckpointLegislationList,
  getSmartFilterCheckpointLegislationRuleList,
  getSmartFilterCheckpointSubEvent,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
  getSmartFilterListManagementList,
} from "@services/list-management.service";
import Notfound from "@components/Not-Found";
import { adminBulkUpdateStatus } from "@services/users.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { handleDownloadOnClick } from "@_common/downloadfile";
import CommonBulkUpload from "@components/BulkUpload";
import { convertDate, convertDateAsString } from "@_common/date-helpers";
import FooterWrapper from "@components/common/FooterWrapper";
import MenuRepositorySvgComponent from "../../../../src/assets/svg-components/left-menu/menurepo";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import CheckpointMasterNotfound from "@components/Page-Not-Found/checkpoint-master-not-found";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import { countKeysWithValues } from "@_common/text-helpers";
import SubmenuArrowDownSvgComponent from "../../../assets/svg-components/left-menu/submenu-arrow-down";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DocumentStorePopup from "@components/common/SelfComplianceDetail/documentStore";
import { allParams } from "@_common/common-helper";

interface ICheckpointActiveProps { }

const ClientCheckpointMaster: React.FunctionComponent<
  ICheckpointActiveProps
> = (props: any) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);

  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };
  const [dropdownOptions, setDropdownOptions] = useState<any>([
    { value: "LOCATION_LICENSES_TASK", label: "License" },
    { value: "LOCATION_LICENSES_UPDATE", label: "License Update" },
    // { value: "RELEASE_VENDOR_CHECKPOINT", label: "Release Vendor Checkpoint" },
    // { value: "PE_COMPLIANCE", label: "PE Compliance" },
    // { value: "SELF_COMPLIANCE", label: "Self Compliance" },
  ]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    getPEComplianceList();
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      getEventsList("", "");
      getSubEventsList("", "");
      getCategoryLawList("", "", "");
      getLegislationList("", "", "", "");
      getLegislationRuleList("", "", "");
    }

    if (getValue(props, `products`, []).includes("VA")) {
      dropdownOptions.push({
        value: "RELEASE_VENDOR_CHECKPOINT",
        label: "Release Vendor Checkpoint",
      });
    }
    if (getValue(props, `products`, []).includes("SELFCOMP")) {
      dropdownOptions.push({
        value: "SELF_COMPLIANCE_CONFIG",
        label: "Self Compliance",
      });

      dropdownOptions.push({
        value: "INTERLINKED_CHECKPOINT",
        label: "Update Interlinkage Checkpoint",
      });

      dropdownOptions.push({
        value: "SELF_COMPLIANCE_MASTER_BULK_UPLOAD",
        label: "Bulk Upload",
      });
    }


    if (getValue(props, `products`, []).includes("PEC")) {
      dropdownOptions.push({ value: "PE_COMPLIANCE", label: "PE Compliance" });
    }

    if (getValue(localStorage, `op`, "") == "true") {
      dropdownOptions.push({ value: "CHECKPOINT", label: "Upload Checkpoint" });
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      setRequest({
        ...request,
        country_id: getValue(params, `country_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        events_id: getValue(params, `events_id`, ""),
        sub_events_id: getValue(params, `sub_events_id`, ""),
      });
      if (getValue(params, `country_id`, "")) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (
        getValue(params, `state_id`, "") ||
        getValue(params, `category_of_law_id`, "") ||
        getValue(params, `legislation_id`, "") ||
        getValue(params, `events_id`, "") ||
        getValue(params, `sub_events_id`, "")
      ) {
        getCategoryLawList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, ""),
        );
        getLegislationList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, ""),
          getValue(params, `legislation_id`, ""),
        );
        getLegislationRuleList(
          "",
          getValue(params, `legislation_id`, ""),
          getValue(params, `legislation_rule_id`, ""),
        );
        getEventsList("", getValue(params, `events_id`, ""));
        getSubEventsList("", getValue(params, `sub_events_id`, ""));
      } else {
        getCategoryLawList("", "", "");
        getLegislationList("", "", "", "");
        getLegislationRuleList("", "", "");
      }
      if (getValue(params, `smart_filter_tags`, "")) {
        getSmartFilterList();
        // getLegislationRuleList(getValue(params, `legislation_id`, ""));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getPayload = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]",
    );
    // let dates = params.date ? new Date(params.date) : new Date();
    // var owner_due_date_from = params.owner_due_date_from
    //   ? params.owner_due_date_from
    //   : new Date(dates.getFullYear(), dates.getMonth(), 1);
    // var owner_due_date_to = params.owner_due_date_to
    //   ? params.owner_due_date_to
    //   : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      // owner_due_date_from: getValue(params, `request_value`, "")
      //   ? ""
      //   : convertDate(owner_due_date_from),
      // owner_due_date_to: getValue(params, `request_value`, "")
      //   ? ""
      //   : convertDate(owner_due_date_to),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      compliance_status: getValue(params, `compliance_status`, ""),
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      self_compliance_task_ids: compliance_task_ids,
      smart_filter_tags: selectedIDs,
      status: "active",
    };
    return { ...payload };
  };

  const [licenseIDs, setLicenseIDs] = useState([]);
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    // let payload: any = {
    //   page_no: params.page_no ? parseInt(params.page_no) : 1,
    //   page_size: params.limit ? parseInt(params.limit) : limit,
    //   search_text: params.search_text,
    //   status: "active",
    //   sort_by: params.sort_by,
    //   country_id: parseInt(getValue(params, `country_id`, "")),
    //   state_id: parseInt(getValue(params, `state_id`, "")),
    //   category_of_law_id: await getSpecificCategoryLawById(
    //     getValue(params, `category_of_law_id`, "")
    //   ),
    //   legislation_id: getValue(params, `legislation_id`, ""),
    //   legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
    //   events_id: parseInt(getValue(params, `events_id`, "")),
    //   sub_events_id: parseInt(getValue(params, `sub_events_id`, "")),
    //   smart_filter_tags: selectedIDs,
    //   compliance_type_id: getValue(params, `compliance_type_id`, ""),
    // };

    let payload: any = {
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      // category_of_law_id: await getSpecificCategoryLawById(
      //   getValue(params, `category_of_law_id`, "")
      // ),
      category_of_law_id: getValue(params, `category_of_law_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      events_id: parseInt(getValue(params, `events_id`, "")),
      sub_events_id: parseInt(getValue(params, `sub_events_id`, "")),

      request_type: getValue(params, `request_type`, "")
        ? getValue(params, `request_type`, "")
        : "",
      request_value: getValue(params, `request_value`, "")
        ? getValue(params, `request_value`, "")
        : "",
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      status: "active",
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let payloadObj = await getPayload();
    let getDocStorepayload: any = {
      checkpoint_id: getValue(request, `checkpoint_id`, ""),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
    };
    try {
      setIsLoading(true);
      let resp = await adminCreateCheckpoint({ ...payload, ...payloadObj });
      let resp1 = await getDocumentCheckpoint(getDocStorepayload);
      if (resp) {
        setList(
          getValue(resp, `data.checkpoints`, []).map((item: object) => ({
            ...item,
            category_of_lawName: getValue(item, `category_of_law.text`, ""),
            compliance_typeName: getValue(item, `compliance_type.text`, ""),
            frequencyName: getValue(item, `frequency.text`, ""),
            compliance_activity: getValue(item, `compliance_activity`, ""),
            legislationName: getValue(item, `legislation.legislation_name`, ""),
            legislation_ruleName: getValue(
              item,
              `legislation_rule.rule_name`,
              "",
            ),
            documentStore: getValue(resp1, `data.checkpoints`, {}),
          })),
        );

        // let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
        //   (item: object) =>
        //     getValue(item, `compliance_type.text`, "") === "License"
        // );
        let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
          (item: object) => {
            const complianceText = getValue(item, `compliance_type.text`, "");
            return ["License", "Approval or Licensing", "Renewal"].includes(
              complianceText,
            );
          },
        );

        setLicenseIDs(
          getValue(licenseIDs, `length`, 0) > 0
            ? licenseIDs.map((item: any) => item.id)
            : [],
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {}),
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
          selectedIndexList.includes(index),
        )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, "")),
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  // const handleDeleteFun = (id: string, value: string) => {
  // 	setDeleteValue(value);
  // 	setDeleteId(id);
  // 	handleDelete();
  // };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificCheckpoint(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) { }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  // const handleChangeSortBy = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.sort_by = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };

  // const handleChangeStatus = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.status = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(50);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/support/detail/${getValue(obj,`original.id`,'')}`)
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const [documentStoreIsOpen, setDocumentStoreIsOpen] = useState(false);
  const handleDocumentStore = () => {
    setDocumentStoreIsOpen(!documentStoreIsOpen);
  };

  const [docStoreData, setDocStoreData] = useState<any>([]);

  const getDocumentStoreData = async (id: string) => {
    let getDocStorepayload: any = {
      checkpoint_id: id,
    };
    let docStoreResp = await getDocumentCheckpoint(getDocStorepayload);
    if (docStoreResp) {
      handleDocumentStore();
      setDocStoreData(getValue(docStoreResp, `data.checkpoints`, []));
    }
  };

  const onPrem = getValue(localStorage, `op`, "") === "true";

  const columns = React.useMemo(
    () => [
      {
        Header: "Checkpoint ID",
        accessor: "checkpoint_id",
        width: 100,
        Cell: ({ row }: any) => {
          return <NavLink to={`#`}>{row.values.checkpoint_id}</NavLink>;
        },
      },
      // {
      // 	Header: "Category of Law",
      // 	accessor: "category_of_lawName",
      // 	width: 250,
      // },
      {
        Header: "Compliance Type",
        accessor: "compliance_typeName",
        width: 150,
      },
      {
        Header: "Legislation",
        accessor: "legislationName",
        width: 350,
      },
      {
        Header: "Rule",
        accessor: "legislation_ruleName",
        width: 350,
      },
      // {
      //   Header: "Compliance Activity",
      //   accessor: "compliance_activity",
      //   width: 450,
      // },
      {
        Header: "Activity",
        accessor: "compliance_activity",
        width: 350,
        Cell: ({ row }) => {
          const complianceActivity = getValue(
            row.original,
            `compliance_activity`,
            "",
          );

          const maxCharCount = 100;
          const [showFullContent, setShowFullContent] = useState(false);

          const toggleContent = (e: any) => {
            e.stopPropagation();
            setShowFullContent(!showFullContent);
          };

          const truncatedContent = complianceActivity
            ? complianceActivity.slice(0, maxCharCount)
            : "";
          return (
            <div>
              {showFullContent ? complianceActivity : truncatedContent}
              {getValue(complianceActivity, `length`, 0) > maxCharCount && (
                <span onClick={toggleContent}>
                  {showFullContent ? (
                    <span style={{ color: "#276ef1" }}>
                      {" "}
                      View less{" "}
                      <span
                        style={{
                          transform: "rotate(180deg)",
                          display: "inline-block",
                        }}
                      >
                        {" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  ) : (
                    <span>
                      {" "}
                      ...{" "}
                      <span style={{ color: "#276ef1" }}>
                        View more{" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  )}
                </span>
              )}
            </div>
          );
        },
      },
      // {
      // 	Header: "Reference",
      // 	accessor: "reference",
      // 	width: 250,
      // },
      {
        Header: "Frequency",
        accessor: "frequencyName",
        width: 120,
      },

      {
        Header: onPrem ? " " : "Reference Document",
        width: onPrem ? 0 : 150,
        Cell: ({ row }: any) => {
          return onPrem ? (
            " "
          ) : (
            <span
              style={{ color: "rgb(39, 110, 241)", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                getDocumentStoreData(row.original.checkpoint_id);
              }}
            >
              View Document
            </span>
          );
        },
      },
      // {
      //   	Header: "DocumentStore",
      //     accessor: "documentStore",
      //   	width: 250,
      //   	Cell: ({ row }: any) => {
      //   		return (
      //         <>
      //           <UncontrolledDropdown>
      //             <DropdownToggle className="primary" color="primary" caret>Dropdown</DropdownToggle>
      //             <DropdownMenu>
      //               <DropdownItem header>Header</DropdownItem>
      //               <DropdownItem disabled>Action</DropdownItem>
      //               <DropdownItem>Another Action</DropdownItem>
      //               <DropdownItem divider />
      //               <DropdownItem>Another Action</DropdownItem>
      //             </DropdownMenu>
      //           </UncontrolledDropdown>
      //         </>
      //       );
      //   	},
      //   },
      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			<>
      // 				<Button
      // 					color="primary"
      // 					onClick={() => handleEdit(row.original.id)}
      // 				>
      // 					Edit
      // 				</Button>
      // 				&nbsp;&nbsp;&nbsp;
      // 				<Button
      // 					color="danger"
      // 					onClick={() =>
      // 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
      // 					}
      // 				>
      // 					Delete
      // 				</Button>
      // 			</>
      // 		);
      // 	},
      // },
    ],
    [],
  );

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    events_id: "",
    sub_events_id: "",
  });
  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: "",
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
      events_id: "",
      sub_events_id: "",
    });
    setSelectedSmartFilterIds([]);
    setResetInput(true);
    // setFilterVisibility(false);
  };

  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
              getValue(item, `is_active`, ""),
            )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) { }
  };

  const [peComplianceList, setPeComplianceList] = useState([]);
  const getPEComplianceList = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
              getValue(item, `is_active`, ""),
            )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setPeComplianceList(obj);
      } else {
      }
    } catch (error) { }
  };

  const getCountriesList = async () => {
    try {
      // let resp = await adminGetCountriesListManagement();
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper(payload);
      let resp = await adminGetCheckpointCountriesListManagement(queryRequest);
      if (resp) {
        setCountryList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `country_id`, ""),
            value: getValue(item, `country_name`, ""),
            label: getValue(item, `country_name`, ""),
          })),
        );
      } else {
      }
    } catch (error) { }
  };

  const getStatesList = async (countryId: number) => {
    let payload = await getPayload();
    let queryRequest = QueryRequestHelper({ ...payload, country: countryId });
    if (countryId) {
      try {
        // let resp = await adminGetStatesListManagement(countryId);
        let resp = await adminGetCheckpointStatesListManagement(queryRequest);
        if (resp) {
          setStates(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `state_id`, ""),
              value: getValue(item, `state_name`, ""),
              label: getValue(item, `state_name`, ""),
            })),
          );
        } else {
        }
      } catch (error) { }
    } else {
      setValue(request, `state_id`, "");
      setRequest({ ...request });
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string,
  ) => {
    if (state_id || getValue(request, `state_id`, "")) {
      setResetInput(false);
      try {
        setResetInput(false);
        setCategoryLawLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          state_id: state_id ? state_id : getValue(request, `state_id`, ""),
          country_id: getValue(request, `country_id`, ""),
          // state_id:state_id,
          id: id,
        };
        let payloadObj = await getPayload();
        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        // let queryRequest = QueryRequestHelper(payload);
        let resp =
          await getSmartFilterCheckpointCategoryOfLawList(queryRequest);
        if (resp) {
          setCategoryOfLawList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `category_of_law_id`, ""),
              // id: getValue(item, `id`, ""),
              value: getValue(item, `category_of_law_text`, ""),
              label: getValue(item, `category_of_law_text`, ""),
            })),
          );
          setCategoryLawLoading(false);
          setValue(request, `category_of_law_id`, "");
        } else {
          setCategoryLawLoading(false);
        }
      } catch (error) {
        setCategoryLawLoading(false);
      }
    } else {
      if (!value) {
        setValue(request, `category_of_law_id`, "");
        setValue(request, `legislation_id`, "");
        setValue(request, `legislation_rule_id`, "");
        setLegislationList([]);
      }
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: "",
    category_of_law_id: string,
    id: string,
  ) => {
    if (category_of_law_id || getValue(request, `category_of_law_id`, "")) {
      try {
        setResetInput(false);
        setLegislationLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          category_of_law_id: category_of_law_id
            ? category_of_law_id
            : getValue(request, `category_of_law_id`, ""),
          state_id: state_id ? state_id : getValue(request, `state_id`, ""),
          id: id,
          country_id: getValue(request, `country_id`, ""),
        };
        let payloadObj = await getPayload();

        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        // let queryRequest = QueryRequestHelper(payload);
        let resp = await getSmartFilterCheckpointLegislationList(queryRequest);
        if (resp) {
          setLegislationList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `legislation_id`, ""),
              value: getValue(item, `legislation_legislation_name`, ""),
              label: getValue(item, `legislation_legislation_name`, ""),
            })),
          );
          setLegislationLoading(false);
          setValue(request, `id`, "");
        } else {
          setLegislationLoading(false);
        }
      } catch (error) {
        setLegislationLoading(false);
      }
      if (!value) {
        setValue(request, `legislation_id`, "");
        setValue(request, `legislation_rule_id`, "");
        setRuleList([]);
      }
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string,
  ) => {
    if (legislation_id || getValue(request, `legislation_id`, "")) {
      try {
        setResetInput(false);
        setLegislationRuleLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          legislation_id: legislation_id
            ? legislation_id
            : getValue(request, `legislation_id`, ""),
          id: id,
          state_id: getValue(request, `state_id`, ""),
          country_id: getValue(request, `country_id`, ""),
          category_of_law_id: getValue(request, `category_of_law_id`, ""),
        };
        let payloadObj = await getPayload();
        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        // let queryRequest = QueryRequestHelper(payload);
        // let resp = await getSmartFilterLegislationRuleList(queryRequest);
        let resp =
          await getSmartFilterCheckpointLegislationRuleList(queryRequest);
        if (resp) {
          setRuleList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `legislation_rule_id`, ""),
              value: getValue(item, `legislation_rule_rule_name`, ""),
              label: getValue(item, `legislation_rule_rule_name`, ""),
            })),
          );
          setLegislationRuleLoading(false);
          setValue(request, `legislation_rule_id`, "");
        } else {
          setLegislationRuleLoading(false);
        }
      } catch (error) {
        setLegislationRuleLoading(false);
      }
      if (!value) {
        setValue(request, `legislation_rule_id`, "");
      }
    }
  };

  /* ---------------------------  Events  ----------------------------- */
  const [eventList, setEventList] = useState([]);
  const [eventLoading, setEventLoading] = useState(false);
  const getEventsList = async (value: string, id: string) => {
    // if (events_id || getValue(request, `events_id`, "")) {
    try {
      setResetInput(false);
      setEventLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "36", //
        group_code: "events",
        events_id: id,
        // state_id: getValue(request, `state_id`, ""),
        // country_id: getValue(request, `country_id`, ""),
        // category_of_law_id: getValue(request, `category_of_law_id`, ""),
        // legislation_rule_id : getValue(request, `legislation_rule_id`, ""),
      };
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      // let queryRequest = QueryRequestHelper(payload);
      // let resp = await getSmartFilterListManagementList(queryRequest);
      let resp = await getSmartFilterCheckpointEvent(queryRequest);
      if (resp) {
        setEventList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `events_id`, ""),
            value: getValue(item, `events_text`, ""),
            label: getValue(item, `events_text`, ""),
          })),
        );
        setEventLoading(false);
        setValue(request, `events_id`, "");
      } else {
        setEventLoading(false);
      }
    } catch (error) {
      setEventLoading(false);
    }
    if (!value) {
      setValue(request, `events_id`, "");
    }
    // }
  };

  /* ---------------------------  Sub events  ----------------------------- */
  const [subEventList, setsub_eventsList] = useState([]);
  const [subEventLoading, setSubEventLoading] = useState(false);
  const getSubEventsList = async (value: string, id: string) => {
    // if (sub_events_id || getValue(request, `sub_events_id`, "")) {
    try {
      setResetInput(false);
      setSubEventLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        // group_id: "35",
        group_code: "sub-events",
        sub_events_id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getSmartFilterListManagementList(queryRequest);
      let resp = await getSmartFilterCheckpointSubEvent(queryRequest);
      if (resp) {
        setsub_eventsList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `sub_events_id`, ""),
            value: getValue(item, `sub_events_text`, ""),
            label: getValue(item, `sub_events_text`, ""),
          })),
        );
        setSubEventLoading(false);
        setValue(request, `sub_events_id`, "");
      } else {
        setSubEventLoading(false);
      }
    } catch (error) {
      setSubEventLoading(false);
    }
    if (!value) {
      setValue(request, `sub_events_id`, "");
    }
    // }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `id`, "");
        setRequest({
          ...request,
          state_id: "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", e.id, "");
      }
    }
    if (type === "category_of_law_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        setLegislationList([]);
        setRuleList([]);
      } else {
        setRequest({
          ...request,
          category_of_law_id: getValue(e, `id`, "") ? e.id : "",
        });
        getLegislationList("", getValue(request, `state_id`, ""), e.id, "");
      }
    }
    if (type === "legislation_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          legislation_id: "",
          legislation_rule_id: "",
        });
        setRuleList([]);
      } else {
        getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
        setRequest({
          ...request,
          legislation_id: getValue(e, `id`, "") ? e.id : "",
          legislation_rule_id: "",
        });
      }
    }
    if (type === "legislation_rule_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          legislation_rule_id: "",
        });
      } else {
        setRequest({
          ...request,
          legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
        });
      }
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "event_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          events_id: "",
        });
      } else {
        setRequest({
          ...request,
          events_id: getValue(e, `id`, "") ? e.id : "",
        });
      }
    }
    if (type === "sub_event_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          sub_events_id: "",
        });
      } else {
        setRequest({
          ...request,
          sub_events_id: getValue(e, `id`, "") ? e.id : "",
        });
      }
    }
  };

  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds),
    );
    if (
      getValue(request, `country_id`, "")
      // getValue(request, `state_id`, "")
      // && getValue(request, `category_of_law_id`, "") &&
      // getValue(request, `legislation_id`, "") &&
      // getValue(request, `legislation_rule_id`, "")
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
        page_no: params.page_no,
        country_id: getValue(request, `country_id`, ""),
        state_id: getValue(request, `state_id`, ""),
        category_of_law_id: getValue(request, `category_of_law_id`, ""),
        legislation_id: getValue(request, `legislation_id`, ""),
        legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
        search_text: getValue(params, `search_text`, ""),
        limit: getValue(params, `limit`, ""),
        events_id: getValue(request, `events_id`, ""),
        sub_events_id: getValue(request, `sub_events_id`, ""),
        smart_filter_tags:
          selectedSmartFilterIdsPayload.length > 0
            ? selectedSmartFilterIdsPayload.map((item: object) =>
              getValue(item, `id`, ""),
            )
            : [],
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      handleFilter();
    } else {
      toast.error("All fields are mandatory");
    }
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, ""),
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, ""),
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, ""),
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, ""),
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") ==
        getValue(request, `legislation_rule_id`, ""),
    );

  let event_ID =
    getValue(eventList, `length`, 0) > 0 &&
    eventList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `events_id`, ""),
    );

  let subevent_ID =
    getValue(subEventList, `length`, 0) > 0 &&
    subEventList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `sub_events_id`, ""),
    );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) { }
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Navigation Routes                             */
  /* -------------------------------------------------------------------------- */

  const handleNavigate = (route: string) => {
    let payload: any = {};
    if (route === "release-to-vendor") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-to-PE") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "add-to-tracker") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-task") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/checkpoint/${route}?${queryRequest}&${allParams()}`);
  };
  const [permissionLoading, setPermissionLoading] = React.useState(true);
  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      // from_date: convertDate(from_date),
      // to_date: convertDate(to_date),
      sort_by: params.sort_by,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      // category_of_law_id: await getSpecificCategoryLawById(
      //   getValue(params, `category_of_law_id`, "")
      // ),
      category_of_law_id: getValue(params, `category_of_law_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      events_id: parseInt(getValue(params, `events_id`, "")),
      sub_events_id: parseInt(getValue(params, `sub_events_id`, "")),
      smart_filter_tags: selectedIDs,
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      report_type: "CHECKPOINT_MASTER",
      report_name: (
        convertDateAsString(from_date) +
        " " +
        "to" +
        " " +
        convertDateAsString(to_date)
      ).toString(),
      is_report: "true",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await exportCheckpointMaster({
        ...payload,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/CHECKPOINT_MASTER`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleNavigateLogs = () => {
    navigate(`/self-compliance-logs/CHECKPOINT_MASTER`);
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "repository_checkpoint_company_master",
        ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={true}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              handleRemoveNavItems={handleRemoveNavItems}
              handleNavigate={handleNavigate}
              permissions={props.permissions}
              products={getValue(props, `products`, [])}
              licenseIDs={licenseIDs}
              assignTask
            />
          )}
          <div className="dashboard-wrapper__header d-flex justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">Master</h4>
            {/* <div
							className="cursor-pointer"
							onClick={() =>
								handleDownloadOnClick(
									"https://asccuriodata.s3.ap-south-1.amazonaws.com/documents/Pe_Compliance_config.xlsx",
									"checkpoint"
								)
							}
						>
							<img
								src="/images/download.svg"
								className="img-fluid add-filter-wrapper__upload-image"
							/>
							<p className="add-filter-wrapper__filter-title">Import</p>
						</div> */}
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Checkpoint
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Master</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                // Mapped Task FH (Function Head)
                mappedTasksFH={false}
                // date range
                dateRange={false}
                // from_date={from_date}
                // to_date={to_date}
                // handleDate={handleDate}
                // // handleCancelDate={handleCancelDate}
                // handleSubmitDate={handleSubmitDate}
                // datePickerRef={datePickerRef}
                //alltime
                allTime={false}
                // handleCheckAlltime={handleCheckAlltime}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}
                //change owner
                changeOwner={false}
                // isOpen={isOpen}
                // handleModal={
                //   getValue(selectedIDs, `length`, 0) > 0
                //     ? handleModal
                //     : () => toast.error("Please select task")
                // }
                // download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
                //logs section
                // viewDownloadedSelfComplianceReports={true}
                handleNavigateLogs={handleNavigateLogs}
                commonUpload={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                dropdownOptions={dropdownOptions}
                commonViewLogs
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
              />
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper `}
            id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
            <div className="admin-wrapper position-relative">
              {/* <div className="admin-wrapper position-relative">
                <SearchHeader
                  route={"/support/details"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add={"false"}
                  isFilterVisible={isFilterVisible}
                  filterCompliance
                  peComplianceList={peComplianceList}
                  handleChangeStatus={handleChangeStatus}
                  commonUpload={
                    getValue(props, `permissions`, []).includes("update")
                      ? true
                      : false
                  }
                  dropdownOptions={dropdownOptions}
                  //download section
                  downloadSelfComplianceReport={true}
                  // viewDownloadedSelfComplianceReports={true}
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                  commonViewLogs
                  handleNavigateLogs={handleNavigateLogs}
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div> */}

              {/* {isFilterVisible && ( */}
              <FilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                countryList={countryList}
                states={states}
                handleChangeSelect={handleChangeSelect}
                additionalFilter={true}
                country_ID={country_ID}
                state_ID={state_ID}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                smartFilterList={smartFilterList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedSmartFilterIds={selectedSmartFilterIds}
                events={true}
                request={request}
                //dynamic filter ( Custom Input Select Dropdown)
                //----> category of law
                categoryOfLawList={categoryOfLawList}
                getCategoryLawList={getCategoryLawList}
                categoryLawLoading={categoryLawLoading}
                cat_ID={cat_ID}
                //----> legislation
                legislationList={legislationList}
                getLegislationList={getLegislationList}
                legislationLoading={legislationLoading}
                leg_ID={leg_ID}
                //----> legislation rule
                ruleList={ruleList}
                getLegislationRuleList={getLegislationRuleList}
                rule_ID={rule_ID}
                legislationRuleLoading={legislationRuleLoading}
                //----> Events
                getEventsList={getEventsList}
                eventLoading={eventLoading}
                event_ID={event_ID}
                eventList={eventList}
                //---->Sub Events
                getSubEventsList={getSubEventsList}
                subEventLoading={subEventLoading}
                subevent_ID={subevent_ID}
                subEventList={subEventList}
                resetInput={resetInput}
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Checkpoint"}
                subModuleName={"Master"}
              />
              {/* )} */}
              {/* <AddFilter
        isFilterVisible={isFilterVisible}
        isFilterHeadingVisible={true}
        isFilterSubHeadingVisible={true}
        isBulkUploadVisible={true}
        addButtonLink={'/checkpoint/active-detail'}
        setFilterFormVisibility={() => {
          setFilterVisibility(!isFilterVisible);
        }}
        />
        */}
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <CheckpointMasterNotfound />
                    </>
                  ) : (
                    <CheckpointMasterNotfound />
                  )}
                </>
              )}
            </div>

            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
              limitToFifty={true}
            />
          </div>

          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />

          <DocumentStorePopup
            docStoreData={docStoreData}
            documentStoreIsOpen={documentStoreIsOpen}
            handleDocumentStore={handleDocumentStore}
          />
        </>
      )}
    </DashboardLayout>
  );
};
export default ClientCheckpointMaster;
